import { useGetSurveysBySociogramId } from '@BUP/hooks/Sociogram/useGetSurveysBySociogramId'
import SociogramInfoCard from '../Generics/Cards/sociogram-info-card'
import SociogramResultsCard from '../Generics/Cards/sociogram-results-card'
import BupSpinner from '../Loading/Spinner'
import SociogramSwitcher from './sociogram-switcher'
import { useGetCurrentCourses } from '@BUP/hooks/Courses/useGetCurrentCourses'
import AlertComponent from '../Generics/Alert'
import { useTranslation } from 'react-i18next'

const SociogramContentTeacher = ({ events, selectedSociogramId, sociogramState, disabled }) => {
  const i18n = useTranslation()
  const {
    data: surveys = [],
    isLoading: isLoadingSurveys,
    error: errorSurveys
  } = useGetSurveysBySociogramId(selectedSociogramId)
  const { isLoading: isLoadingCourses, error: errorCourses, courses } = useGetCurrentCourses()

  if (isLoadingSurveys || isLoadingCourses) return <BupSpinner size='medium' />

  if (errorSurveys || errorCourses) return <AlertComponent message={i18n.t('common.resources.survey.actions.read.failure')} type='error' />

  const courseId = courses && courses[0].courseId

  const survey = surveys.find(survey => survey.courses[0].id === courseId)

  if (!survey) return <AlertComponent message={i18n.t('common.resources.survey.actions.read.failure_not-found-course')} type='info' />

  return (
    <>
      <SociogramSwitcher
        sociogramState={sociogramState}
        events={events}
        disabled={disabled}
      />
      <SociogramInfoCard survey={survey} />
      <SociogramResultsCard sociogramId={selectedSociogramId} survey={survey} />
    </>
  )
}

export default SociogramContentTeacher
